import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Wrapper, Header, CellContainer, GridColumn } from './styled';
import StatusCell from '../../status-cell';
import { isDefined } from '../../../helpers/utils';

const CollapsedGrid = ({ activities, topicId, i18n }) => {
  const assignments = useSelector(
    (state) => state.CourseAssignReducer.assignments
  );

  const sortedStudents = useSelector(
    (state) => state.CourseAssignReducer.sortedStudents
  );

  const datePreference = useSelector((state) =>
    state.CourseAssignReducer?.datePreference?.length > 0
      ? state.CourseAssignReducer?.datePreference
      : [undefined, undefined]
  );

  const courseId = useSelector(
    (state) => state.CourseAssignReducer.activeCourseID
  );

  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );
  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);
  return (
    <Wrapper>
      <Header />
      <GridColumn>
        {sortedStudents.map((sortedStudent) => {
          let resultSum = 0;
          let cellsWithResult = 0;
          let hasAssignments = false;
          let selectedCells = 0;
          const { encryptedUserProfileId } = sortedStudent;
          const students = assignments.studentAssignments.filter((student) => {
            if (student.encryptedUserProfileId === encryptedUserProfileId) {
              activities.forEach((activity) => {
                if (
                  student.activityId === activity.activityId &&
                  student.taskType === activity.taskType
                ) {
                  if (isDefined(student?.result?.score)) {
                    cellsWithResult++;
                    resultSum += student.result.score;
                  }

                  if (isDefined(student.assignment)) {
                    hasAssignments = true;
                  }

                  if (student.isSelected) {
                    selectedCells++;
                  }
                }
              });
              return true;
            }
            return false;
          });

          const resultAverage =
            cellsWithResult > 0 ? resultSum / cellsWithResult : 0;

          return (
            <CellContainer key={encryptedUserProfileId}>
              <StatusCell
                i18n={i18n}
                activities={activities}
                topicId={topicId}
                key={encryptedUserProfileId}
                studentInfo={students[0]}
                currentStudent={sortedStudent}
                hasAssignments={hasAssignments}
                hasResults={cellsWithResult > 0}
                resultAverage={resultAverage}
                selectedCells={selectedCells}
                isCollapsed
                datePreference={datePreference}
                courseId={courseId}
                classroomId={classroomId}
                groupId={groupId}
              />
            </CellContainer>
          );
        })}
      </GridColumn>
    </Wrapper>
  );
};

CollapsedGrid.propTypes = {
  activities: PropTypes.array,
  topicId: PropTypes.number.isRequired,
  i18n: PropTypes.object
};

CollapsedGrid.defaultProps = {
  activityIds: []
};

export default CollapsedGrid;



// WEBPACK FOOTER //
// ./components/grid/collapsed/index.js